export default {
  'createBill.purchaseorderno':
    "Numero d'Ordine d'Acquisto Iran Branch Office, No.18, Alvand Building, Alvand St.Indirizzo sede Iran: Via Alvand, Palazzo Alvand, Numero 18   Argentina Sq., Tehran, Iran.Iran, Tehran, Piazza Argentina Phone: +98 21 88663088`,	Telefono: +98 21 88663088",
  'createBill.date': 'Data',
  'createBill.supplieraddress': 'Indirizzo del Fornitore',
  'createBill.3061valiasrsttehraniran':
    'Iran, Tehran, Via Valiasr, numero 3061',
  'createBill.requestername': 'Nome del Richiedente',
  'createBill.paymentterms': 'Condizioni del Pagamento',
  'createBill.frominvoicereceipt': 'dalla ricevuta della fattura',
  'createBill.projectname': 'Nome del Progetto',
  'createBill.test': 'Prova',
  'createBill.pos': 'POS',
  'createBill.description': 'Descrizione',
  'createBill.quantity': 'Quantità',
  'createBill.uom': 'UOM',
  'createBill.netprice': 'Prezzo Netto',
  'createBill.per': 'Per',
  'createBill.totalprice': 'Prezzo Totale',
  'createBill.curr': 'Curr',
  'createBill.deliverydate': 'Data di Consegna',
  'createBill.NECfullHD1024': 'NEC - Full HD 1024',
  'createBill.sonyultraHD': 'SONY - Ultra HD',
  'createBill.xiaominormalheadset': 'Xiaomi - Normal Headset',
  'createBill.beatshighqualitywireless': 'Beats - High Quality - Wireless',
  'createBill.totalgrossamount':
    'IMPORTO LORDO TOTALE(comprese eventuali tasse)',
  'createBill.months': 'Mese',
  'createBill.hours': 'Ora',
  'createBill.days': 'Giorno',
  'createBill.novartispharmaserviceAG': 'Novartis Pharma Service AG',
};
